import React, { ReactNode } from 'react'

export type SortDirection = 'asc' | 'desc'
export type SortPrimitive = string | number | Date | null | undefined

export type RowSortValue = {
  disabled?: boolean
  value: SortPrimitive

  /** Orders rows with equal values, in the same direction. */
  tiebreak?: SortPrimitive
}

export const normalizeSortValue = (v: SortPrimitive): string | number => {
  if (v == null) return ''
  if (v instanceof Date) return v.getTime()
  if (typeof v === 'number') return v

  return String(v).trim()
}

export const compareNormalized = (a: string | number, b: string | number) => {
  const bothNumbers = typeof a === 'number' && typeof b === 'number'

  if (bothNumbers) return a - b

  return String(a).localeCompare(String(b), undefined, {
    numeric: true,
    sensitivity: 'base'
  })
}

export const extractFallback = (node: ReactNode): string | number => {
  if (node == null || typeof node === 'boolean') return ''
  if (typeof node === 'number') return node
  if (typeof node === 'string') return node.trim()

  if (React.isValidElement(node)) {
    const children = (node.props as any)?.children

    if (typeof children === 'string') return children.trim()
    if (typeof children === 'number') return children
    if (Array.isArray(children)) {
      return children
        .map((c) => (typeof c === 'string' || typeof c === 'number' ? c : ''))
        .join('')
        .trim()
    }
  }

  return ''
}
